import { Stack } from "@mui/material"
import PropTypes from "prop-types"
import React from "react"
import { TransformComponent, TransformWrapper, useControls } from "react-zoom-pan-pinch"
import { ATTACHMENT_TYPES } from "../../../utilities/constants"
import { UiCtButton } from "../MuiStyled/LibComponent"
import { UiIconWrapper } from "../MuiStyled/Span"

const ImageControls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls()

  return (
    <Stack
      component={"div"}
      spacing={2}
      direction={"row"}
      className="tools"
      sx={{ position: "absolute", top: "30px", right: "50%", transform: "translateX(50%)" }}
    >
      <UiCtButton variant="contained" onClick={() => zoomIn()}>
        Zoom In
        <UiIconWrapper color="inherit" sx={{ ml: 1 }}>
          <i className="fa-solid fa-magnifying-glass-plus"></i>
        </UiIconWrapper>
      </UiCtButton>
      <UiCtButton variant="contained" onClick={() => zoomOut()}>
        Zoom Out
        <UiIconWrapper color="inherit" sx={{ ml: 1 }}>
          <i className="fa-solid fa-magnifying-glass-minus"></i>
        </UiIconWrapper>
      </UiCtButton>
      <UiCtButton variant="outlined" onClick={() => resetTransform()}>
        Reset
        <UiIconWrapper color="inherit" sx={{ ml: 1 }}>
          <i className="fa-solid fa-reply"></i>
        </UiIconWrapper>
      </UiCtButton>
    </Stack>
  )
}

function AttachmentModal({ title, subTitle, actionButtons, attachments }) {
  return (
    <div className="attachment-modal-content">
      <h3 className="modal-title">{title}</h3>
      <p className="modal-subtitle">{subTitle}</p>
      <div className="modal-attachments-wrapper">
        {attachments?.map((attach, attachIdx) => {
          if (attach.type === ATTACHMENT_TYPES.IMAGE) {
            return (
              <TransformWrapper initialScale={1} key={attachIdx}>
                {() => (
                  <>
                    <ImageControls />
                    <TransformComponent
                      contentStyle={{
                        cursor: "grab",
                      }}
                    >
                      <img className="modal-image" src={attach.src} alt={attach.alt} key={attachIdx} />
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            )
          }
          return <></>
        }) ?? <></>}
      </div>
      <div className="modal-action-wrapper">
        {actionButtons.map((button, btnIndex) => (
          <button key={`info-btn-${btnIndex}`} className={`btn ${button.classNames.join(" ")}`} onClick={button.clickHandler}>
            {button.text}
          </button>
        ))}
      </div>
    </div>
  )
}

AttachmentModal.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      classNames: PropTypes.array,
      clickHandler: PropTypes.func,
    })
  ).isRequired,
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ),
}

export default AttachmentModal
